import { Suspense, lazy, type ReactNode } from "react";
import { Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider";
import { AppHeader } from "./components/AppHeader";
import { SkipLink, StatePanel } from "./components/primitives";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { LoginScreen } from "./screens/LoginScreen";
import { DashboardScreen } from "./screens/DashboardScreen";
import { AssumptionsScreen } from "./screens/AssumptionsScreen";

// Code-split the spokes (NFR1.2): they load on navigation, not on first paint.
const ProjectionScreen = lazy(() =>
  import("./screens/ProjectionScreen").then((m) => ({ default: m.ProjectionScreen })),
);
const MonteCarloScreen = lazy(() =>
  import("./screens/MonteCarloScreen").then((m) => ({ default: m.MonteCarloScreen })),
);

function Screen({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary fallback={<main className="app-main"><StatePanel kind="error" /></main>}>
      <Suspense fallback={<main className="app-main"><StatePanel kind="loading" /></main>}>{children}</Suspense>
    </ErrorBoundary>
  );
}

export function App() {
  const { ready, authed } = useAuth();

  if (!ready) return <StatePanel kind="loading" />;
  if (!authed) return <LoginScreen />;

  return (
    <>
      <SkipLink />
      <AppHeader />
      <Routes>
        <Route path="/" element={<Screen><DashboardScreen /></Screen>} />
        <Route path="/assumptions" element={<Screen><AssumptionsScreen /></Screen>} />
        <Route path="/projection" element={<Screen><ProjectionScreen /></Screen>} />
        <Route path="/montecarlo" element={<Screen><MonteCarloScreen /></Screen>} />
        <Route path="*" element={<Screen><DashboardScreen /></Screen>} />
      </Routes>
    </>
  );
}
